'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const SearchIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="SearchIcon">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
          <path
            id="Vector"
            d="M1.26562 6.4341C1.26562 7.82145 1.81674 9.15197 2.79774 10.133C3.77874 11.114 5.10926 11.6651 6.4966 11.6651C7.88395 11.6651 9.21447 11.114 10.1955 10.133C11.1765 9.15197 11.7276 7.82145 11.7276 6.4341C11.7276 5.04676 11.1765 3.71624 10.1955 2.73524C9.21447 1.75424 7.88395 1.20313 6.4966 1.20312C5.10926 1.20313 3.77874 1.75424 2.79774 2.73524C1.81674 3.71624 1.26563 5.04676 1.26562 6.4341V6.4341Z"
            stroke={sx?.color ? sx.color : '#B0BBCB'}
            strokeWidth="1.3125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M13.297 13.2344L10.1956 10.1329"
            stroke={sx?.color ? sx.color : '#B0BBCB'}
            strokeWidth="1.3125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

SearchIcon.propTypes = {
  sx: PropTypes.object
}
